// extracted by mini-css-extract-plugin
export default {"active":"TabSelector_active__Wl1gd","inactive":"TabSelector_inactive__DOMkA"};